import { Injectable } from '@angular/core';
import { CasePermission } from 'src/app/auth/domain/enums/case-permission.enum';
import { CaseRole } from 'src/app/auth/domain/enums/case-role.enum';
import { AuthorizationStateBase } from './authorization-state.base';

/**
 * State service for managing case management authorization data.
 * Provides type-safe access to user's case role and permissions.
 */
@Injectable({ providedIn: 'root' })
export class CaseAuthorizationState extends AuthorizationStateBase<CaseRole, CasePermission> {}